import React from 'react';

const Icon = (props: { icon: string }) => (
    <i className="iconify" data-icon={props.icon} data-inline="false"></i>
);

export default Icon;
